<template>
  <a-upload
    :showUploadList="false"
    accept=".srt,.vtt"
    :customRequest="handleSubtitleUpload"
  >
    <a-button type="primary" :loading="uploadLoading" v-if="hasSubtitle">更换</a-button>
    <a-button :loading="uploadLoading" v-else> <a-icon type="upload" /> 上传 </a-button>
  </a-upload>
</template>

<script>
import { updateGather } from '@/api/video/gather'
import { uploadOss, uploadObject } from '@/api/tool/oss'

const SUBTITLE_FIELD_MAP = {
  1: { field: 'subtitle', prefix: 'subtitle/zh' },
  2: { field: 'subtitleEn', prefix: 'subtitle/en' },
  3: { field: 'subtitleAb', prefix: 'subtitle/ab' },
  4: { field: 'subtitleTc', prefix: 'subtitle/tc' },
  5: { field: 'subtitleKo', prefix: 'subtitle/ko' },
  6: { field: 'subtitleVi', prefix: 'subtitle/vi' },
  7: { field: 'subtitleFr', prefix: 'subtitle/fr' },
  8: { field: 'subtitleJp', prefix: 'subtitle/jp' }
}

export default {
  name: 'gatherUploadBtn',
  props: {
    customInfo: {
      type: Object
    },
    customIndex: {
      type: Number
    },
    customType: {
      type: Number
    }
  },
  data() {
    return {
      uploadLoading: false
    }
  },
  computed: {
    hasSubtitle() {
      const config = SUBTITLE_FIELD_MAP[this.customType]
      return config && this.customInfo[config.field]
    }
  },
  methods: {
    /**
     * 字幕文件上传：阿里云 OSS 直传（凭证由 /common/oss 返回）
     */
    async handleSubtitleUpload(info) {
      const fileName = info.file.name
      if (fileName.indexOf('vtt') < 0 && fileName.indexOf('srt') < 0) {
        this.$message.warning('请上传 vtt 或 srt 文件')
        if (info.onError) {
          info.onError(new Error('文件类型不正确'))
        }
        return
      }

      const config = SUBTITLE_FIELD_MAP[this.customType]
      if (!config) {
        this.$message.error('未知的字幕类型')
        if (info.onError) {
          info.onError(new Error('未知的字幕类型'))
        }
        return
      }

      this.uploadLoading = true
      if (info.onProgress) {
        info.onProgress({ percent: 0 })
      }

      try {
        const filePath = uploadOss(fileName, config.prefix)
        const url = await uploadObject(filePath, info.file, (progress) => {
          if (info.onProgress && progress && progress.percent != null) {
            info.onProgress({ percent: Math.round(progress.percent * 100) })
          }
        })

        this.customInfo[config.field] = url
        await updateGather(this.customInfo)
        this.$emit('change')
        this.$message.success('上传成功')
        if (info.onSuccess) {
          info.onSuccess({ url }, info.file)
        }
      } catch (error) {
        console.error('字幕上传失败:', error)
        this.$message.error(error.message || '上传失败，请重试')
        if (info.onError) {
          info.onError(error)
        }
      } finally {
        this.uploadLoading = false
      }
    }
  }
}
</script>

<style scoped>

</style>
